var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.isLive)?_c('div',{staticClass:"live-sinal"},[_vm._m(0)]):_c('div',{staticClass:"preview-sinal"},[_c('span',[_vm._v("直播"+_vm._s(_vm.liveTime)+"开始")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('span',{staticClass:"first"}),_c('span',{staticClass:"second"}),_c('span',{staticClass:"third"}),_vm._v("正在直播\n        ")])
}]

export { render, staticRenderFns }